import { React, useRef, useEffect } from 'react';
import { Tr, Td, Button, Tooltip, Input, SaveIcon, ButtonGroup, CloseIcon, FormControl } from '@atlas-design-system/react';

export function NewRecordRow(props) {

    useEffect(() => {
        firstInputRef.current?.focus();
    }, []);

    const { table, cellInfo, cellValueChanged, addNewRecord, setEditing } = props;

    const firstInputRef = useRef(null);
    const firstEditableId = table.getAllColumns().find(a => a.columnDef.editable)?.id;

    return (<Tr key='editRow'>
        {table.getAllColumns().map((column, i) => {
            if (column.columnDef.accessorKey === 'actions') {
                return (<Td key={column.id}>
                    <ButtonGroup style={{ justifyContent: 'flex-end' }}>
                        <Tooltip content='Save new record' delayShow={500}>
                            <Button appearance='tertiary'
                                icon={<SaveIcon />}
                                disabled={!cellInfo.every(r => r.isValid)}
                                style={{ marginRight: 0 }}
                                onClick={() => addNewRecord(table.getAllColumns())} />
                        </Tooltip>
                        <Tooltip content='Cancel' delayShow={500}>
                            <Button appearance='tertiary' icon={<CloseIcon />}
                                onClick={() => setEditing(false)} />
                        </Tooltip>
                    </ButtonGroup>
                </Td>)
            } else if (column.columnDef.editable) {
                var currentRecord = { ...cellInfo.find(r => r.id === column.id) };
                const itemProps = column.id === firstEditableId ? { ref: firstInputRef } : {};
                return (<Td key={column.id}>
                    <FormControl hideLabel label="" error={currentRecord.error}
                    >
                        <Input required={column.columnDef.required}
                            value={currentRecord.value}
                            {...itemProps}
                            onKeyDown={e => {
                                if (e.key === 'Enter') {
                                    addNewRecord(table.getAllColumns());
                                }
                            }}
                            onChange={e => cellValueChanged(column, currentRecord, e.target.value.toUpperCase())} />
                    </FormControl>

                </Td>)

            } else {
                return (<Td key={column.id}></Td>)
            }
        }
        )}
    </Tr>)
}